import { getIt } from "../uikit/getIt";
import { isEmpty, get, escape } from "lodash";
import { Api } from "../uikit/service/api";
import { useStore } from "react-redux";
import { MessageCenter } from "imagica-corekit/dist/base/kernel/MessageCenter";

export default function useHandleAskBrainData({ postWithStreaming, setNodeParam, setNodes }) {
  const store = useStore();
  const api = new Api(false);

  const getAskBrainData = async (text, edgeParam, defaultData) => {
    const messageCenter = getIt(MessageCenter);
    const { target, id, source } = edgeParam;
    const meId = store.getState().editor.me?.id;
    const selectedTemplateId = store.getState().studio.selectedTemplate?.id;
    const enableAskBrainStreaming =
      get(store.getState().editor.me, "feature_tags", []).includes("disable_studios_ask_brain_streaming") === false;
    const enableAskBrainSocket =
      get(store.getState().editor.me, "feature_tags", []).includes("disable_studios_ask_brain_socket") === false;
    const topic = `/studios/${meId}/wsuid_${
      selectedTemplateId ? selectedTemplateId + "_" : ""
    }${target}/ask_brain/${Date.now()}`;
    const postBody = { query: encodeURIComponent(text) };
    if (enableAskBrainSocket) {
      // websocket
      messageCenter.on(topic, res => {
        const result = {
          query: text,
          answer: res.message,
          latency: {},
          sources_data: [],
        };
        setNodeParam({
          id: target,
          data: {
            ...defaultData,
            displayType: "askBrain",
            textAreaValue: result,
          },
        });
      });
      postBody.pubsub_topic = topic;
    }
    if (enableAskBrainStreaming) {
      postBody.stream_version = "v1";
      postBody.stream = true;
      let temp = "";
      await postWithStreaming(
        `/stream/langchain/v5/ask_brain`,
        postBody,
        msg => {
          temp += msg.choices?.[0]?.text || msg.choices?.[0]?.delta?.content || "";
          setNodeParam({
            id: target,
            data: {
              showWarning: false,
              displayType: "askBrain",
              textAreaValue: {
                answer: temp.trim(),
              },
            },
          });
        },
        false,
        postInstance => {
          setNodeParam({
            id: target,
            data: {
              showStopGenerateBtn: true,
              abortNode: {
                source,
                target,
                edgeId: id,
                apiInstance: postInstance,
              },
            },
          });
        },
        allDataStr => {
          const sourceReg = /(\{\"sources_data\": \{.*\}\})/g;
          const execArr = sourceReg.exec(allDataStr);
          if (!isEmpty(execArr)) {
            try {
              const obj = JSON.parse(execArr[1]);
              const sourcesData = Object.entries(obj.sources_data).map(([, value]) => value);
              setNodes(prevList => {
                return prevList.map(l => {
                  if (l.id === target) {
                    return {
                      ...l,
                      data: {
                        ...l.data,
                        textAreaValue: {
                          ...l.data.textAreaValue,
                          sources_data: sourcesData,
                        },
                      },
                    };
                  }
                  return l;
                });
              });
            } catch (error) {}
          }
        }
      );
    } else {
      const url = `/be/langchain/v5/ask_brain`;
      const currentPromise = api.postWithErrorCanAbort(url, postBody);
      setNodeParam({
        id: target,
        data: {
          showStopGenerateBtn: true,
          abortNode: {
            source,
            target,
            edgeId: id,
            apiInstance: currentPromise,
          },
        },
      });
      return currentPromise
        .then(res => {
          // 对象结构转为数组
          res.data.sources_data = Object.entries(res.data.sources_data).map(([, value]) => value);
          setNodeParam({
            id: target,
            data: {
              ...defaultData,
              displayType: "askBrain",
              textAreaValue: res.data,
            },
          });
        })
        .catch(error => Promise.reject(error));
    }
  };
  return {
    getAskBrainData,
  };
}
